'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$() {
  this.aSZ = null;
  this.aT0 = false;
  this.aT1 = null;
  this.aT2 = false;
  this.aST = null;
  this.aSU = false;
  this.aSV = null;
  this.aSW = false;
  this.aSX = null;
  this.aSY = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$ = this;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeBigDecimal__$init$__V(this);
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$.prototype = $p;
$p.aA = (function() {
  if ((!this.aT0)) {
    this.aSZ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeBigDecimal$$anon$1(this);
    this.aT0 = true;
  }
  return this.aSZ;
});
$p.o3 = (function() {
  if ((!this.aT2)) {
    this.aT1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeBigDecimal$$anon$3(this);
    this.aT2 = true;
  }
  return this.aT1;
});
$p.iq = (function() {
  if ((!this.aSU)) {
    this.aST = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aSU = true;
  }
  return this.aST;
});
$p.J2 = (function(x$0) {
});
$p.jh = (function() {
  if ((!this.aSW)) {
    this.aSV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lalleycats_Empty$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => {
      var $x_1 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$();
      var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_package$().ox();
      var e$proxy6 = $x_1.iu(this$1.pp(0, this$1.hX));
      if ((e$proxy6 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), (("Expected Right, got Left(" + e$proxy6.bj) + ")"));
      }
      if ((e$proxy6 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        return e$proxy6.aI;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e$proxy6);
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Empty$());
    this.aSW = true;
  }
  return this.aSV;
});
$p.Jm = (function() {
  if ((!this.aSY)) {
    this.aSX = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "VAT Rate";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aSY = true;
  }
  return this.aSX;
});
$p.bY0 = (function(rate) {
  $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$();
  var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_BigDecimal$();
  return rate.adA(this$1.pp(100, this$1.hX));
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$, "app.data.data_point_types$package$VATRate$", ({
  GE: 1,
  B: 1,
  C: 1,
  cz: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VATRate$ };
//# sourceMappingURL=app.data.data_point_types$package$-V-A-T-Rate$.js.map
